// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Dv385","textarea":"styles_textarea__3r_HE"};